export enum TaskStatuses {
  Pending = 1,
  Departed = 2,
  Arrived = 3,
  TaskStarted = 4,
  TaskPaused = 5,
  TaskResumed = 6,
  TaskCompleted = 7,
  CheckedOut = 9,
  None = 0,
}
export enum JobRejectListType {
  None = 0,
  JobApprovalPending = 1,
  TenantPosted = 2,
  PendingOwnerApproval = 3,
  PmAcceptOwnerRejection = 4,
}
export enum JobRuleTriggerType {
  Emergency = -1,
  TenantPosted = 1,
  Drafted = 2,
  Quoted = 3,
  SentForOwnerApproval = 4,
  QuotesPending = 5,
  RevisionRequested = 6,
  QuoteAccepted = 7,
  Scheduled = 8,
  VariationRecevied = 9,
  VariationSent = 10,
  ExternalJobPosted = 11,
  PendingInvoice = 12,
  PendingReview = 13,
  SiteVisit = 14,
  AvailableToQuote = 15,
  DraftedQuotes = 16,
  SPRevisionRequested = 17,
  UnSchedule = 18,
  PendingSchedule = 19,
  Overdue = 20,
  VariationReceivedSentBySubcontractor = 21,
  VariationReceivedSentByPM = 22,
  SPVariationSent = 23,
  InProgress = 24,
  InvoicePendingReview = 25,
  SPPendingInvoice = 26,
  JobApprovalPending = 27,
  SPScheduled = 28,
  WorkOrder = 29,
  PmPendingSchedule = 30,
  OwnerApproved = 31,
  TenantManagedPendingReview = 33,
  QuotesAvailable = 34,
  QuotesPendingAutomation = 35,
  InspectionDrafted = 42 //added type to both old and new project: AN-59090
}

export enum UrgencyTypes {
  Emergency = -1,
  Urgently = 1,
  WithinAFewDays = 2,
  WithinAWeek = 3,
  ByThisDate = -999,
}
export enum AttachmentType {
  Other = 0,
  Licence = 1,
  Insurance = 2,
  JobCreate = 3,
  JobCompleteConsumer = 4,
  JobCompleteProvider = 5,
  InvoiceByProvider = 6,
  Signature = 7,
  PropertyComponent = 8,
  PropertyComponentFeature = 9,
  SharedDocument = 10,
  JobNoteAttachment = 11,
  PropertyComponentThumbnail = 12,
  OfflinePropertyInspection = 13,
  JobRejectTenant = 14,
  JobCompleteProviderDraft = 15,
  InvoiceByProviderDraft = 16,
  JobVariation = 17,
  RevisePrice = 18,
  InspectionESignature = 19,
  OwnerTemplateCover = 20,
  TenantTemplateCover = 21,
  CommunicationTemplate = 22,
  InspectionsPmToTenant = 23,
  InspectionsPmToOwner = 24,
  CommunicationTemplateLogo = 25,
  InspectionMaintenance = 26,
  Emails = 27,
  TenantInvoice = 28,
  PmAcceptedQuoteAttachment = 29,
  CreditorInvoice = 30,
  InvoiceWithWatermarkByProvider = 31
}
export enum InvoiceHistoryType {
  Variation = 1,
  InvoiceVariation = 2,
  QuoteRevision = 3,
}

export enum JobTypeEnum {
  OpenJob = 1,
  closedJob = 2,
  reccurringJob = 3,
}

export enum ChannelType {
  Unknown = 0,
  Web = 1,
  iOS = 2,
  Android = 3,
  Email = 4,
  Sms = 5,
  Ivr = 6,
  Messenger = 7,
  Whatsapp = 8,
  GoogleHome = 9,
  API = 10,
  WeChat = 11,
  AgencyChatBot = 12,
}

export enum IssueReportedType {
  Email = 1,
  TenantCall = 2,
  InvoiceOnly = 3,
}

export enum ActivationStatus {
  PendingApproval = 1,
  Approved = 2,
  Suspended = 3,
  Expired = 4,
  PaymentPending = 5,
  MobileVerificationPending = 6,
  Deactivated = 7,
  NotRegistered = 8,
}
